<template>
    <div class="moe_bottom flex Flexjustify Flexalign">
        <div class="moe_bottom_box">
            <div class="moe_bottom_top flex FlexBetween">
                <div class="moe_bottom_top_left">
                    <div class="flex Flexalign">
                        <el-image class="total_icon" :src="iconPath('nishang_logo_icon.png')"></el-image>
                        <div class="logo_title mar_left_15">冠军高考专家辅导课</div>
                    </div>
                    <div class="mar_top_10">逆熵启航，升学有方</div>
                </div>
                <div class="moe_bottom_top_right flex">
                    <div class="link_box">
                        <div class="link_title">友情链接</div>
                        <div class="link_text cursor_pointer" @click="goNewLink(configInfo.GJZY_LINK)">冠军志愿</div>
                        <!-- <div class="link_text">启航教育机构</div>
                        <div class="link_text">梦远方</div> -->
                    </div>
                    <div class="link_box">
                        <div class="link_title">更多</div>
                        <div class="link_text cursor_pointer" @click="goAgreement('user_privacy_agreement')">隐私协议</div>
                        <div class="link_text cursor_pointer" @click="goNormalQuestion">帮助中心</div>
                    </div>
                    <div class="link_box">
                        <div class="link_title">关注我们</div>
                        <div class="flex link_text">
                            <div class="qr_code_box flex flexcolumn Flexjustify Flexalign">
                                <el-image class="weibo_white_icon cursor_pointer"
                                    :src="imgPath('guanjun_public_qrcode.jpg')"
                                    :preview-src-list="[imgPath('guanjun_public_qrcode.jpg')]"></el-image>
                            </div>
                            <div class="qr_code_box mar_left_20 flex flexcolumn Flexjustify Flexalign">
                                <el-image class="weibo_white_icon cursor_pointer"
                                    :src="imgPath('nishang_public_qrcode.jpg')"
                                    :preview-src-list="[imgPath('nishang_public_qrcode.jpg')]"></el-image>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="organization_info">
                <div>{{ configInfo.RECORD_COMPANY }} | <span class="cursor_pointer" @click="goBeian">{{ configInfo.RECORD_NAME }}</span></div>
                <!-- <div @click="goAgreement('user_privacy_agreement')" class="cursor_pointer mt-10">隐私协议</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import * as Config from "@/config/config.js";
export default {
    name: 'GjkcH5MoeBottom',

    data() {
        return {
            configInfo: {}
        };
    },

    mounted() {
        this.configInfo = Config;
    },

    methods: {
        goNewLink(url) {
            window.open(url);
        },
        goAgreement(type){
            this.$Jump.href("/privacyAgreement", { type });
        },
        goBeian(){
            window.open('https://beian.miit.gov.cn/#/Integrated/index');
        },
        goNormalQuestion(){
            this.$Jump.href("/normalQuestion");
        }
    },
};
</script>
<style lang="scss" scoped>
.moe_bottom {
    width: 100%;
    height: 240px;
    background: #242324;
    color: RGBA(255, 255, 255, 0.4);

    .moe_bottom_box {
        width: $pageMainWidth;

        .moe_bottom_top {
            .moe_bottom_top_left {
                .total_icon {
                    height: 51px;
                    width: 90px;
                }

                .logo_title {
                    font-size: 20px;
                    color: #FFFFFF;
                    font-family: Source Han Serif CN;
                }
            }

            .moe_bottom_top_right {
                .link_box {
                    margin-left: 52px;

                    .link_title {
                        font-size: 16px;
                        opacity: 0.6;
                    }

                    .link_text {
                        font-size: 14px;
                        margin-top: 12px;
                    }

                    .qr_code_box {
                        width: 100px;
                        height: 100px;
                        background: #FFFFFF;
                    }

                    .weibo_white_icon {
                        width: 98px;
                        height: 98px;
                    }
                }
            }
        }

        .organization_info {
            width: 100%;
            margin-top: 12px;
            text-align: center;

            .police_icon {
                width: 18px;
                height: 20px;
            }
        }
    }
}
</style>